import http from "../http-common";
import router from '../router'
class LoginService {

  setUserInfo(loginRs) {
    let idEntitat  = loginRs.idEntitat;

    localStorage.setItem('access_token', loginRs.access_token);
    localStorage.setItem('refresh_token', loginRs.refresh_token);
    localStorage.setItem('roles', loginRs.roles);
    if(idEntitat != null){
      localStorage.setItem('idEntitat', idEntitat);
    }
  }
  getAccessToken() {
    return localStorage.getItem('access_token');
  }
  getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }
  getIdEntitat() {
    return localStorage.getItem('idEntitat');
  }
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    if(this.hasRole('admin-enquesta')||this.hasRole('direccio')){
      router.push('/login');
    }

    localStorage.removeItem('roles');
     
  }
  login(data) {
    return http.get("/login/auth",{auth: {
      username: data.usuari,
      password: data.pass
    }});
  }
  loginAccessKey(access_key) {
    return http.get("/login/access/"+ access_key);
  }
  isLoggedIn(){        
    return this.getAccessToken()?true:false;
  }
  hasRole(role){
    console.log(localStorage.getItem('roles'))
    return localStorage.getItem('roles') && localStorage.getItem('roles').includes(role)
  }

}

export default new LoginService();